import { BasicSelectInput, DateRangeInput } from '@shared/ui/forms/inputs';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ThemeButton } from '@shared/ui/buttons';
import {
  setBalancesParams,
  resetBalancesFilters,
} from '@app/store/slices/balancesSlice';
import { useDispatch, useSelector } from 'react-redux';
import { filterOperationTypes } from '@utils/filters-helpers';
import { paymentStatusesOptions } from '@utils/statuses';
import { parseDateQuery, formatDateQuery } from '@utils/date-helpers';

export default function BalanceFilters({ close }) {
  const { t } = useTranslation();
  const { params } = useSelector((state) => state.balances);
  const dispatch = useDispatch();

  const { control, handleSubmit } = useForm({
    defaultValues: {
      operationDate:
        params.start_date && params.end_date
          ? [parseDateQuery(params.start_date), parseDateQuery(params.end_date)]
          : null,
      type: params.type ?? null,
      status: params.status ?? null,
    },
  });

  function onSubmit(formData) {
    const start_date = formatDateQuery(formData.operationDate?.[0]);
    const end_date = formatDateQuery(formData.operationDate?.[1]);
    dispatch(
      setBalancesParams({
        page: 1,
        start_date,
        end_date,
        type: formData.type,
        status: formData.status,
      }),
    );
    close();
  }

  function handleReset() {
    dispatch(resetBalancesFilters());
    close();
  }

  return (
    <>
      <div className="block-pd-x drawerFilter-grow">
        <div className="form">
          <BasicSelectInput
            control={control}
            name="type"
            label={t('operation')}
            data={filterOperationTypes('balance')}
            valueKey="value"
            labelKey="label"
          />
          <BasicSelectInput
            control={control}
            name="status"
            label={t('status')}
            data={paymentStatusesOptions}
            valueKey="value"
            labelKey="label"
          />
          <DateRangeInput
            control={control}
            name="operationDate"
            label={t('operation_date')}
          />
        </div>
      </div>
      <div className="btns-toolbar dialog-actions">
        <ThemeButton startIcon="check" onClick={handleSubmit(onSubmit)}>
          {t('apply')}
        </ThemeButton>
        <ThemeButton appearance="secondary" onClick={handleReset}>
          {t('reset')}
        </ThemeButton>
      </div>
    </>
  );
}
